import classNames from "classnames";
import { ReactNode } from "react";
import {
  LoadingSpinner,
  LoadingSpinnerProps,
} from "../LoadingSpinner/LoadingSpinner";

type Props = {
  content?: ReactNode | string;
  children: ReactNode;
  isLoading: boolean;
} & Partial<Pick<LoadingSpinnerProps, "iconColor">>;

export const OverlayLoader = ({
  children,
  content,
  isLoading,
  iconColor,
}: Props) => {
  return (
    <div className="relative">
      <div
        className={classNames(
          "absolute left-0 top-0 z-[38] flex h-full w-full bg-white bg-opacity-75 text-center",
          { invisible: !isLoading }
        )}
      >
        <div className="m-auto text-gray-600">
          {content || (
            <LoadingSpinner isLoading isOverlay={false} iconColor={iconColor} />
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default {};
